import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface AuthDiags {
  RmiAuthNo: string;
  RmiCompanyId: string;
  RmiCreatedBy: string;
  RmiCreatedDate: string;
  RmiDiag: string;
  RmiDiagDesc: string;
  RmiDiagFromDate: string;
  RmiDiagRefNo: number;
  RmiModifiedBy: string;
  RmiModifiedDate: string;
  RmiRowId: string;
  RmiUid: number;
}

export const getPortalAuth = (authNo: string, companyId: string, userRole: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PORTAL_AUTH_REQUEST });

  return api.authorization.portal.get(authNo, companyId, userRole)
    .then((res: any) => {

      dispatch({
        type: types.GET_PORTAL_AUTH_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PORTAL_AUTH_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
